import React from 'react';
import Error404Component from "../components/error-404-components/Error404Component"; // Иконка предупреждения

export default function Error404() {return <Error404Component/>}

